import { updateStateData } from './updateStateData'

export const clearStateData = (stateKey: string) =>
  updateStateData(stateKey, {
    loading: false,
    data: undefined,
    error: undefined
  })
